<template>
  <div id="dashboard-plans">
    <b-container>
      <div class="d-flex align-items-center">
        <!-- <div class=""> -->
        <!-- <b-input-group class="mt-3 w-50 mx-auto" >
            <template #append>
                <b-input-group-text><strong class="text-dark ">!</strong></b-input-group-text>
            </template>
            <b-form-input class="bg-dark text-primary" placeholder="Search edibles"></b-form-input>
          </b-input-group>     -->

        <!-- <b-input-group  class=' mx-auto search'>
            <b-form-input class="bg-dark search-feild" v-model="search" placeholder=""></b-form-input>
            <label for="" v-if="search.length < 1" class="mb-0">find edibles</label>
            <i class="fa fa-search"></i>
        </b-input-group>          -->
        <!-- </div> -->
        <PageTitle title="Edibles" backLink="/farms" class="px-0" />
        <div class="cart pointer ml-auto" @click="handleCheckout()">
          <i class="fas fa-shopping-cart text-dark w-100"></i>
          <span
            v-if="CartItems.length > 0"
            class="badge badge-danger rounded-pill"
            >.</span
          >
        </div>
      </div>
      <b-row>
        <b-col cols="12" lg="12" class="mb-4 portfolio-card mt-5">
          <b-col class="dash-card bg-dark p-3 px-4 dash shadow-xl">
            <b-row class="py-4">
              <b-col cols="12" md="6">
                <div class="text-primary">
                  <p class="text-light mb-0">
                    Deliveries available in <br />
                    <span class="text-primary">Lagos, Abeokuta</span>
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </b-container>

    <!-- <PageTitle title="Farm For Me" backLink="/farms" /> -->
    <b-container class="pb-5 mt-3">
      <b-row align-v="stretch">
        <b-col cols="12">
          <b-tabs v-model="activeTab">
            <b-tab title="Products">
              <Products class="mt-4" @setActiveTab="activeTab = 1" />
            </b-tab>
            <b-tab title="My Orders">
              <Orders @setInvestTab="activeTab = 0" v-if="activeTab == 1" />
            </b-tab>
            <b-tab title="Pending">
              <Pending @setInvestTab="activeTab = 0" v-if="activeTab == 2" />
            </b-tab>
            <b-tab>
              <template #title>
                <p class="mb-0" @click="handleCheckout()">My Cart</p>
              </template>
              <Products class="mt-5" @setActiveTab="activeTab = 1" />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>

    <!-- <InvestModal /> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DateTime as LuxonDateTime } from "luxon";
import Orders from "./components/order";
import Pending from "./components/pending";
import Products from "./components/products";
import CartDrawer from "./components/drawers/cartDrawer";
import PageTitle from "@/components/ui/PageTitle";
// import { formatMoney } from "@/utils/helpers";
// import PageTitle from "@/components/ui/PageTitle";
// import NewPlans from "./components/NewPlans";
// import Oppurtunities from "./components/oppurtunities";
// import Activelans from "./components/ActivePlan";
// import PendingPlans from "./components/PendingPlan";

export default {
  data() {
    return {
      search: "",
      investments: [],
      activeInvestment: {},
      LuxonDateTime: LuxonDateTime,
      activeTab: 0,
    };
  },
  async created() {
    var hash = location.hash.substr(1);
    switch (hash) {
      case "":
        this.activeTab = 0;
        break;
      case "active-plans":
        this.activeTab = 1;
        break;
      case "pending":
        this.activeTab = 2;
        break;
      case "my-cart":
        this.handleCheckout();
        // this.activeTab = 3;
        break;
      default:
    }
  },

  methods: {
    handleCheckout() {
      const panelResult = this.$showPanel({
        component: CartDrawer,
        openOn: "right",
        width: "495px",
        disableBgClick: true,
        props: {},
      });

      panelResult.promise.then((result) => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }
        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },
  },

  computed: {
    ...mapGetters(["CartItems"]),
  },

  components: {
    Orders,
    Products,
    Pending,
    PageTitle,
    // formatMoney
    // PageTitle,
    // NewPlans,
    // Activelans,
    // PendingPlans,
    // Oppurtunities
  },
};
</script>

<style lang="scss">
.search {
  width: 500px;
  transition: 0.25s ease-in-out;
  position: relative;
  // 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  // 0 100px 80px rgba(0, 0, 0, 0.12);

  .search-icon {
    border: 1px solid rgba(151, 151, 151, 0.486);
    border-left: none;
  }
  .search-feild {
    color: rgb(0, 0, 0);
    // padding: ;
    transition: 0.4s ease-in-out;
    outline: none !important;
    padding: -5px 0 0 30px !important;
    background: rgb(255, 255, 255) !important;
  }
  .search-feild:focus ~ i {
    right: 20px;
  }

  .search-feild:focus ~ label {
    left: 20px;
  }

  label {
    left: 40%;
    top: 8px;
    font-size: 20px;
    z-index: 1000;
    display: inline;
    position: absolute;
    transition: 0.5s ease-in-out;
    color: rgba(78, 77, 77, 0.733);
  }

  i {
    position: absolute;
    top: 15px;
    right: 47%;
    z-index: 1000;
    color: rgba(78, 77, 77, 0.733);
    transition: 0.5s ease-in-out;
  }

  .search-feild:focus {
    outline: none !important;
  }
}
.increase-font {
  font-size: 25px;
  font-weight: bolder;
}

.dash-card {
  position: relative;
  z-index: 2;
}

.dash-card i {
  padding: 15px 0;
  border-radius: 30px;
  color: #333;
}

.dash-card .h6-l {
  margin-top: 20px;
}

.dash-card::after {
  content: "";
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.07;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.dash-card.rent::after {
  // background-image: url("~@/assets/images/rental.svg");
  background-position: center;
}

.dash-card.dash::after {
  background-image: url("~@/assets/images/ether2.svg");

  opacity: 1;
  background-position: bottom;
  background-color: #333;
  border-radius: 5px;
}

.cart {
  position: relative;
  margin-top: 10px;
  i {
    font-size: 22px;
  }
  span.badge {
    height: 10px;
    width: 5px;
    top: -3px;
    right: -4px;
    position: absolute;
  }
}
.investment-blocks {
  transition: all 0.25s ease;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
}

.invest-btn {
  transition: all 0.25s ease;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

  &:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
}

.cart:hover {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
@media only screen and (max-width: 1240px) {
  .search {
    label {
      left: 40%;
    }

    i {
      right: 42%;
    }
  }
}
@media only screen and (max-width: 768px) {
  .search {
    label {
      left: 40%;
    }

    i {
      right: 40%;
    }
  }
}

@media only screen and (max-width: 767px) {
  .search {
    label {
      left: 20px;
    }

    i {
      right: 20px;
    }
  }
}
</style>
